import { render, staticRenderFns } from "./TrendChartDashboard.vue?vue&type=template&id=b76e3c24&"
import script from "./TrendChartDashboard.vue?vue&type=script&lang=js&"
export * from "./TrendChartDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports